export default __webpack_public_path__ + "static/denis-7c1fdda2f1a8fb7c42e2387f96fb2551.png";